import { useOpenOrders } from './useOpenOrders'
import { useUnsettledBalances } from './useUnsettledBalances'

export const useOrdersCount = () => {
  const { openOrders } = useOpenOrders()
  const { unsettledBalances } = useUnsettledBalances()
  const openOrdersCount = openOrders?.length || 0
  const unsettledCount = unsettledBalances?.length || 0
  const ordersCount = openOrdersCount + unsettledCount
  return { ordersCount, openOrdersCount, unsettledCount }
}
